<template>
  <div class="workbench-content" v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(255, 255, 255, 0.3)">
    <div class="header-row">
      <div class="page-title">
        <img :src="iconImg" class="title-icon" />
        <span class="main-title">拍摄</span>
        <div class="title-decoration">
          <img :src="titleImg" class="title-decoration-img" />
        </div>
      </div>
      <div class="date-picker-wrapper">
        <span class="date-label">预计上线时间：</span>
        <el-date-picker
          v-model="searchForm.date"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          size="mini"
          unlink-panels
          @change="initData"
          class="custom-date-picker"
          :clearable="false"
          :editable="false"
        >
        </el-date-picker>
        <i class="el-icon-date date-icon-suffix"></i>
      </div>
    </div>
    <div class="cards-row">
      <div class="card-item" v-for="(item, index) in cardsData" :key="index" @click="handleCardClick(item)">
        <div class="card-title-row">
          <span class="card-title">{{ item.title }}</span>
          <el-tooltip content="延期待完成产品 + 回退待完成 + 正常待完成产品；" placement="top" v-if="index === 0">
            <i class="el-icon-question help-icon"></i>
          </el-tooltip>
        </div>
        <div class="card-content">
          <div class="card-number" :class="item.color">{{ item.value || 0 }}</div>
          <div class="card-sub">共计 {{ item.subText || 0 }}个 SPU</div>
          <div class="card-sub" v-if="index == 1">最长延期SPU时间： {{ delayDays || 0 }}天</div>
        </div>
      </div>
      <div class="card-item gauge-card">
        <div class="card-title-row">
          <span class="card-title">平均耗时统计(天)</span>
          <el-tooltip content="汇总所有产品的用时完成时间（完成拍摄时间 – 维护拍摄计划时间）/ 产品个数；" placement="top">
            <i class="el-icon-question help-icon"></i>
          </el-tooltip>
        </div>
        <div class="gauge-chart-wrapper">
          <div class="number-display">
            <img :src="numberImg" class="number-bg" />
            <span class="number-val">{{ gaugeValue || 0 }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="tables-row">
      <div class="table-group">
        <div class="table-box table-box-with-header">
          <div class="panel-header">
            <span class="panel-title">平均耗时排名</span>
            <el-tooltip content="根据组内每个小伙伴的平均耗时进行统计数据排名；" placement="top">
              <i class="el-icon-question help-icon"></i>
            </el-tooltip>
          </div>
          <div class="panel-content">
            <div class="table-header-row">
              <span class="th name">姓名</span>
              <span class="th value">耗时天数</span>
              <span class="th rank">排名</span>
            </div>
            <div class="table-body">
              <div class="table-row" v-for="item in leftTableData.slice(0, 5)" :key="item.rank" :class="{ 'highlight-row': item.name === loginUserName }">
                <span class="td name">{{ item.name }}</span>
                <span class="td value">{{ item.days }}</span>
                <span class="td rank">{{ item.rank }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="table-box table-box-no-header">
          <div class="panel-content">
            <div class="table-body body-right" v-if="leftTableData.length > 5">
              <div class="table-row" v-for="item in leftTableData.slice(5, 10)" :key="item.rank" :class="{ 'highlight-row': item.name === loginUserName }">
                <span class="td name">{{ item.name }}</span>
                <span class="td value">{{ item.totalProductQty }}</span>
                <span class="td rank">{{ item.rank }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="table-group">
        <div class="table-box table-box-with-header">
          <div class="panel-header">
            <span class="panel-title">待完成总数排名</span>
            <el-tooltip content="根据组内每个小伙伴的待完成产品总数进行统计数据排名；" placement="top">
              <i class="el-icon-question help-icon"></i>
            </el-tooltip>
          </div>
          <div class="panel-content">
            <div class="table-header-row">
              <span class="th name">姓名</span>
              <span class="th value">待完成总数</span>
              <span class="th rank">排名</span>
            </div>
            <div class="table-body">
              <el-tooltip
                v-for="item in rightTableData.slice(0, 5)"
                :key="item.rank"
                effect="light"
                placement="top"
                :open-delay="500"
                popper-class="shooting-tooltip"
              >
                <div slot="content" class="tooltip-content">
                  <div class="tooltip-item">
                    <div class="tooltip-label">延期待完成</div>
                    <div class="tooltip-value">{{ item.delayQty || 0 }}</div>
                  </div>
                  <div class="tooltip-item">
                    <div class="tooltip-label">回退待完成</div>
                    <div class="tooltip-value">{{ item.backQty || 0 }}</div>
                  </div>
                  <div class="tooltip-item">
                    <div class="tooltip-label">正常待完成</div>
                    <div class="tooltip-value">{{ item.normalQty || 0 }}</div>
                  </div>
                </div>
                <div class="table-row" :class="{ 'highlight-row': item.name === loginUserName }">
                  <span class="td name">{{ item.name }}</span>
                  <span class="td value">{{ item.totalProductQty }}</span>
                  <span class="td rank">{{ item.rank }}</span>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="table-box table-box-no-header">
          <div class="panel-content">
            <div class="table-body body-right" v-if="rightTableData.length > 5">
              <el-tooltip
                v-for="item in rightTableData.slice(5, 10)"
                :key="item.rank"
                effect="light"
                placement="top"
                :open-delay="500"
                popper-class="shooting-tooltip"
              >
                <div slot="content" class="tooltip-content">
                  <div class="tooltip-item">
                    <div class="tooltip-label">延期待完成</div>
                    <div class="tooltip-value">{{ item.delayQty || 0 }}</div>
                  </div>
                  <div class="tooltip-item">
                    <div class="tooltip-label">回退待完成</div>
                    <div class="tooltip-value">{{ item.backQty || 0 }}</div>
                  </div>
                  <div class="tooltip-item">
                    <div class="tooltip-label">正常待完成</div>
                    <div class="tooltip-value">{{ item.normalQty || 0 }}</div>
                  </div>
                </div>
                <div class="table-row" :class="{ 'highlight-row': item.name === loginUserName }">
                  <span class="td name">{{ item.name }}</span>
                  <span class="td value">{{ item.totalProductQty }}</span>
                  <span class="td rank">{{ item.rank }}</span>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import headerBoxImg from '@/assets/images/workbench_img/headerBox.png';
import numberImg from '@/assets/images/workbench_img/number.png';
import titleImg from '@/assets/images/workbench_img/title.png';
import iconImg from '@/assets/images/workbench_img/icon.png';

export default {
  name: 'ShootingModule',
  computed: {
    loginUserName() {
      return this.$store.state.user.name;
    },
  },
  data() {
    return {
      searchForm: {
        date: [moment().subtract(6, 'months').format('YYYY-MM-DD'), moment().add(3, 'months').format('YYYY-MM-DD')],
      },
      cardsData: [
        { title: '待完成产品总计', value: 0, subText: 0, color: 'text-green' },
        { title: '延期待完成产品', value: 0, subText: 0, color: 'text-yellow' },
        { title: '回退待完成产品', value: 0, subText: 0, color: 'text-orange' },
        { title: '正常待完成产品', value: 0, subText: 0, color: 'text-blue' },
      ],
      gaugeValue: 0,
      delayDays: 0,
      leftTableData: [],
      rightTableData: [],
      headerBoxImg,
      numberImg,
      titleImg,
      iconImg,
      loading: false,
      getDataObj: {},
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      this.getDataObj = {
        dts: this.searchForm.date[0],
        dte: this.searchForm.date[1],
        type: 103,
        userId: this.$store.state.user.userId,
      };
      this.loading = true;
      await this.getSpuStatics();
      await this.querySpuStaticsDay();
      await this.querySpuStaticsFinish();
      this.loading = false;
    },
    getSpuStatics() {
      let data = this.getDataObj;
      return this.$q.dataBoard.getSpuStatics({ data }).then((res) => {
        this.cardsData[0].value = res.data.totalProductQty;
        this.cardsData[0].subText = res.data.totalSpuQty;
        this.cardsData[1].value = res.data.delayProductQty;
        this.cardsData[1].subText = res.data.delaySpuQty;
        this.cardsData[2].value = res.data.backProductQty;
        this.cardsData[2].subText = res.data.backSpuQty;
        this.cardsData[3].value = res.data.normalProductQty;
        this.cardsData[3].subText = res.data.normalSpuQty;
        this.gaugeValue = res.data.averageDays;
        this.delayDays = res.data.delayDays;
      });
    },
    querySpuStaticsDay() {
      let data = {
        pageNum: 1,
        pageSize: 999,
        filterData: this.getDataObj,
      };
      return this.$q.dataBoard.querySpuStaticsDay({ data }).then((res) => {
        this.leftTableData = res.data.list;
      });
    },
    querySpuStaticsFinish() {
      let data = {
        pageNum: 1,
        pageSize: 999,
        filterData: this.getDataObj,
      };
      return this.$q.dataBoard.querySpuStaticsFinish({ data }).then((res) => {
        this.rightTableData = res.data.list;
      });
    },
    handleCardClick(item) {
      let status = item.title.includes('延期') ? '0' : item.title.includes('回退') ? '1' : item.title.includes('正常') ? '2' : '';
      this.$router.push({
        path: '/newProduct/newproduct-process',
        query: {
          devicePerson: this.$store.state.user.name,
          startTime: this.searchForm.date[0],
          endTime: this.searchForm.date[1],
          taskIds: 103,
          status,
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.workbench-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background: url('../../../../assets/images/workbench_img/content.png') no-repeat center;
  background-size: 100% 100%;
  padding-bottom: 20px
  height: 580px;
  gap: 10px;
}

.header-row {
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 10px
    border-left: 3px solid #95FEFF
    background: linear-gradient(90deg, rgba(0,60,50,0.5) 0%, rgba(0,0,0,0) 100%);
    margin-bottom: 5px;
}

.page-title {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-right: 30px;
}

.title-icon {
    height: 20px;
    margin-right: 5px;
}

.main-title {
    font-size: 20px;
    font-family: 'FZLTTH';
    letter-spacing: 1px;
    background: linear-gradient(180deg, #FFFFFF 0%, #B1FFFC 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;

}

.title-decoration {
    margin-left: 10px;
    display: flex;
    align-items: center;
}

.title-decoration-img {
    height: 16px;
    opacity: 0.7;
}

.date-picker-wrapper {
    display: flex;
    align-items: center;
    position: relative;
}

.date-label {
    font-size: 14px;
    color: #D4FFFF;
    margin-right: 10px;
    font-family: PingFangSC;
}

.custom-date-picker {
    width: 220px !important;
    background: transparent !important;
    border: 1px solid #0BB78E !important;
    border-radius: 2px !important;
    padding-right: 30px !important;

    >>> .el-range-input {
        background: transparent !important;
        color: #7BFFE0 !important;
        font-size: 12px;
    }
    >>> .el-range-separator {
        color: #7BFFE0 !important;
        line-height: 22px;
    }
    >>> .el-input__icon {
        display: none;
    }
}

.date-icon-suffix {
    position: absolute;
    right: 10px;
    color: #7BFFE0;
    pointer-events: none;
}

.cards-row {
    display: flex;
    gap: 10px;
    height: 240px;
    padding: 0 20px
    flex-shrink: 0;
}

.card-item {
    flex: 1;
    position: relative;
    background: rgba(5, 72, 56, 0.6);
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    border-radius: 4px;
    cursor: pointer;
}

.card-title-row {
    display: flex;
    align-items: center;
    height: 42px;
    background: url('../../../../assets/images/workbench_img/headerBox.png') no-repeat center;
    background-size: 100% 100%;
    padding-left: 10px;
    margin-bottom: 10px;
    position: relative;
    font-family: 'FZLTZHK', sans-serif;
}

.card-title {
    font-size: 14px;
    color: #fff;
    margin-right: 5px;
    font-weight: 500;
}

.help-icon {
    color: rgba(255,255,255,0.5);
    font-size: 14px;
    cursor: pointer;
    margin-right: auto;
}

.card-content {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex: 1;
    padding-bottom: 15px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 35px;
}

.card-number {
    font-family: 'PingFangBold', sans-serif;
    font-size: 40px;
    color: #2EF9C6;
    margin-bottom: 30px;
    font-weight: bold;
}

.text-green { color: #4BEDD2; }
.text-orange { color: #F0714B; }
.text-yellow { color: #FFF6A4; }
.text-blue { color: #54AFFF; }

.card-sub {
    font-size: 14px;
    color: #D4FFFF;
    text-shadow: 1px 2px 4px rgba(3,28,78,0.23);
    font-family: 'AlibabaHuiTi', sans-serif;
    margin-bottom: 10px;
}

.gauge-card {
    display: flex;
    flex-direction: column;
}

.gauge-chart-wrapper {
    flex: 1;
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.number-display {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.number-bg {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.number-val {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%); /* Slight adjustment for visual center */
    font-family: 'PingFangBold', sans-serif;
    font-size: 40px;
    color: #fff;
    font-weight: bold;
}

/* Tables Row */
.tables-row {
    flex: 1;
    display: flex;
    gap: 10px;
    min-height: 0;
    padding: 0 20px
}

.table-group {
    flex: 1;
    display: flex;
}

.table-box {
    flex: 1;
    position: relative;
    background: rgba(5, 72, 56, 0.6);
    padding: 0;
    display: flex;
    flex-direction: column;
}

.table-box-with-header {
    border-radius: 4px 0 0 4px;
}

.table-box-no-header {
    border-radius: 0 4px 4px 0;
}

.panel-header {
    display: flex;
    align-items: center;
    height: 42px;
    background: url('../../../../assets/images/workbench_img/headerBox.png') no-repeat center;
    background-size: 100% 100%;
    padding-left: 10px;
    margin-bottom: 0;
    width: calc(20vw - 60px);
    font-family: 'FZLTZHK', sans-serif;
}

.panel-title {
    font-size: 14px;
    margin-right: 5px;
    color: #fff;
}

.panel-content {
    flex: 1;
    overflow: hidden;
    padding: 15px 20px;
    display: flex;
    flex-direction: column;
}

.table-box-no-header .panel-content {
    padding-left: 0;
}

.table-header-row {
    display: flex;
    padding: 8px 0;
    color: #8DEDDD;
    font-size: 14px;
}

.th, .td {
    text-align: center;
}

.th.name, .td.name { flex: 1; text-align: left; padding-left: 15px; }
.th.value, .td.value { flex: 1; }
.th.rank, .td.rank { flex: 1; }

.table-body {
    flex: 1;
    overflow-y: auto;
    padding-top: 5px;
}

.body-right {
  padding-top: 12px
}

.table-row {
    display: flex;
    padding: 8px 0;
    font-size: 14px;
    color: #fff;
    /* 保留左右边框，只去掉行与行之间的顶部重叠 */
    border-bottom: 1px solid #1D6052;
    border-left: 1px solid #1D6052;
    border-right: 1px solid #1D6052;
    background: #0B5042;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      cursor: pointer
      // background: rgba(11, 133, 127, 0.6)
    }
}

.highlight-row {
  background: rgba(11, 133, 127, 0.6) !important;
}

.table-box .table-body .table-row:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.table-box .table-body .table-row:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}

::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}
::-webkit-scrollbar-track {
    background: rgba(255,255,255,0.02);
}
::-webkit-scrollbar-thumb {
    background: rgba(46, 249, 198, 0.2);
    border-radius: 2px;
}
</style>

<style lang="stylus">
.shooting-tooltip {
  .tooltip-content {
    display: flex;
    gap: 20px;
    text-align: center;
  }
  .tooltip-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .tooltip-label {
    font-size: 12px;
    color: #333;
    margin-bottom: 5px;
  }
  .tooltip-value {
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }
}
</style>
